import React, { useEffect, useMemo, useRef, useState } from "react";
import { Skeleton, Stack } from "@mui/material";
import { useQuestionMeta } from "../../context/assessSections/QuestionMetaContext";
import { useQuestionLibrary } from "../../context/assessSections/QuestionLibraryContext";
import { useHistory, useLocation } from "react-router-dom";
import { HiQuestionMarkCircle } from "react-icons/hi2";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import MainButton from "../../components/common/MainButtonComponent";
import SectionTopicHeader from "../../components/common/SectionTopicHeader";
import { routes } from "../../helper/routes";
import QuestionLibraryFilter from "./QuestionLibraryFilter";
import QuestionLibraryList from "./QuestionLibraryList";
import { sectionItems } from "./assessSectionData";
import "./AssessShared.css";
import "./QuestionLibrary.css";
import { QuestionMetaProvider } from "../../context/assessSections/QuestionMetaContext";
import { QuestionLibraryProvider } from "../../context/assessSections/QuestionLibraryContext";
import { Switch, Route } from "react-router-dom";
import QuestionDetailPage from "./QuestionDetailPage";
import QuestionEditorForm from "./QuestionEditorForm";
import { QuestionEditorProvider } from "../../context/assessSections/QuestionEditorContext";
import {
  ViewQuestionProvider,
} from "../../context/assessSections/ViewQuestionContext";
import QuestionDetailPageContent from "./QuestionDetailPage";
import AssessmentPagination from "./AssessmentPagination";

function QuestionLibrarySectionContent() {
  const { loadQuestionMetaData } = useQuestionMeta();
  const history = useHistory();
  const location = useLocation();
  const libraryChangedRef = useRef(false);
  //console.log("QuestionLibrarySectionContent render");

  useEffect(() => {
    //console.log("QuestionLibrarySection MOUNTED");

    return () => {
      //console.log("QuestionLibrarySection UNMOUNTED");
    };
  }, []);
  const getInitialScreen = () => {
    const params = new URLSearchParams(location.search);
    return (
      params.get("screen") ||
      sessionStorage.getItem("questionLibraryScreen") ||
      "list"
    );
  };

  const getInitialQuestionId = () => {
    const params = new URLSearchParams(location.search);
    return (
      params.get("id") ||
      sessionStorage.getItem("questionLibraryQuestionId") ||
      null
    );
  };

  const {
    activeTab,
    setActiveTab,
    activeItems,
    loading,
    error,
    fetchQuestions,
    // fetchMyQuestions,
    // fetchAllQuestions,
    query,
    // applyQuery,
    totalRealCount,
    totalPublicRealCount,
    deleteQuestionFromLibrary,
    refreshBothTabs,
    changePage,
    changePageSize,
    currentPage,
    pageSize,
  } = useQuestionLibrary();

  const didInitialLoadRef = useRef(false);


  const [screen, setScreen] = useState(getInitialScreen);
  const [selectedQuestionId, setSelectedQuestionId] = useState(getInitialQuestionId);

  useEffect(() => {
    if (didInitialLoadRef.current) return;

    didInitialLoadRef.current = true;

    const loadPageData = async () => {
      try {
        // console.log("QuestionLibrarySection initial load, screen:", screen);

        await loadQuestionMetaData({
          scope: "library",
          forceRefresh: true,
        });

        if (screen === "list") {
          //console.log("Fetching question library list...");
          await fetchQuestions();
        }

        else { }
      } catch (err) {
        console.error("QuestionLibrarySection load failed:", err);
      }
    };

    loadPageData();
  }, []);

  useEffect(() => {
    if (screen === "create" || screen === "edit") {
      loadQuestionMetaData({
        scope: "create",
        includeAssessments: false,
      });
    }

    if (screen === "createWithAssessment") {
      loadQuestionMetaData({
        scope: "create",
        includeAssessments: true,
      });
    }
  }, [screen, loadQuestionMetaData]);
  const [deletingId, setDeletingId] = useState(null);

  const navigateScreen = (nextScreen, questionId = null) => {
    setScreen(nextScreen);
    setSelectedQuestionId(questionId);

    if (nextScreen === "list") {
      sessionStorage.removeItem("questionLibraryScreen");
      sessionStorage.removeItem("questionLibraryQuestionId");
    } else {
      sessionStorage.setItem("questionLibraryScreen", nextScreen);

      if (questionId) {
        sessionStorage.setItem("questionLibraryQuestionId", questionId);
      }
    }
    
  };
  // const goToView = (item) =>
  //   history.push(`${routes.ques_lib}/view/${item.question_id}`);
  const goToView = (item) => {
    const questionId = item.question_id || item.raw?.question_id;
    navigateScreen("view", questionId);
  };

  // const goToEdit = (item) =>
  //   history.push(`${routes.ques_lib}/edit/${item.question_id}`);

  // const goToEdit = (item) => {
  //   const questionId = item.question_id || item.raw?.question_id;

  //   history.push(routes.ques_lib_edit.replace(":id", questionId));
  // };

  const goToEdit = (item) => {
    const questionId = item.question_id || item.raw?.question_id;
    navigateScreen("edit", questionId);
  };

  const ensureListLoaded = async () => {
    if (activeItems.length === 0 && totalRealCount === 0 && totalPublicRealCount === 0) {
      await fetchQuestions(query, true);
    }
  };

  const goBackToList = async () => {
    navigateScreen("list");

    if (libraryChangedRef.current) {
      libraryChangedRef.current = false;

      await loadQuestionMetaData({
        scope: "library",
        forceRefresh: true,
      });

      await refreshBothTabs(true);
      return;
    }

    await ensureListLoaded();
  };

  const headerActions = (
    <div className="assess-section__header-actions">
      <MainButton
        action="create"
        icon="add"
        label="Create question with assessment"
        tone="success"
        // onClick={() => history.push(routes.ques_lib_create_with_assessment)}
        onClick={() => navigateScreen("createWithAssessment")}
      />
      <MainButton
        action="create"
        icon="add"
        label="Create question"
        tone="primary"
        // onClick={() => history.push(routes.ques_lib_create)}
        onClick={() => navigateScreen("create")}
      />
    </div>
  );

  const handleDeleteQuestion = async (item) => {
    // prevent duplicate deletes for the same item
    if (deletingId === item.id) return;

    const result = await window.Swal.fire({
      title: "Do you want to remove the question?",
      text: `Are you sure you want to delete ${item.name}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
    });

    if (!result.isConfirmed) return;

    try {
      setDeletingId(item.id);
      await deleteQuestionFromLibrary(item.raw);
      await window.Swal.fire({
        title: "Success!",
        text: "Question deleted successfully.",
        icon: "success",
      });
    } catch (error) {
      await window.Swal.fire({
        title: "Failed",
        text: error.message || "Unable to delete question.",
        icon: "error",
      });
    }
    finally {
      setDeletingId(null);
    }
  };

  if (screen === "view") {
    return (
      <QuestionDetailPageContent
        questionId={selectedQuestionId}
        onBack={goBackToList}
      />
    );
  }

  if (screen === "edit") {
    return (
      <ContentWrapper>
        <QuestionEditorProvider
          includeAssessments={false}
          editQuestionId={selectedQuestionId}
        >
          <QuestionEditorForm
            title="Edit Question"
            mode="edit"
            withAssessment={false}
            showCreateButton={false}
            onBack={goBackToList}
            onCancel={goBackToList}
            onSave={async () => {
              libraryChangedRef.current = true;
              await goBackToList();
            }}
          />
        </QuestionEditorProvider>
      </ContentWrapper>
    );
  }

  if (screen === "create") {
    return (
      <ContentWrapper>
        <QuestionEditorProvider>
          <QuestionEditorForm
            title="Create Question"
            onBack={goBackToList}
            onCancel={goBackToList}
            // onSave={async () => {
            //   await refreshBothTabs(true);
            //   goBackToList();
            // }}
            onSave={async () => {
              libraryChangedRef.current = true;
              await goBackToList();
            }}
          />
        </QuestionEditorProvider>
      </ContentWrapper>
    );
  }

  if (screen === "createWithAssessment") {
    return (
      <ContentWrapper>
        <QuestionEditorProvider includeAssessments>
          <QuestionEditorForm
            title="Create Question with Assessment"
            withAssessment
            onBack={goBackToList}
            onCancel={goBackToList}
            onSave={async () => {
              libraryChangedRef.current = true;
              await goBackToList();
            }}
          />
        </QuestionEditorProvider>
      </ContentWrapper>
    );
  }
  return (
    <ContentWrapper>
      <section className="assess-section">
        <SectionTopicHeader
          className="assess-topic-header"
          title="Question Library"
          subtitle="Create, review and manage question content"
          icon={<HiQuestionMarkCircle />}
          color="#734EBC"
          colorAlt="#D97706"
        />

        <div className="assess-toprow">
          <div
            className="assess-tabs question-tabs"
            role="tablist"
            aria-label="Question library tabs"
          >
            <button
              type="button"
              className={`assess-tab ${activeTab === "my" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("my");
                // fetchMyQuestions(query);
              }}
            >
              My Questions
            </button>
            <button
              type="button"
              className={`assess-tab ${activeTab === "all" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("all");
                // fetchAllQuestions(query);
              }}
            >
              All Questions
            </button>
          </div>

          <div className="assess-toprow__actions">{headerActions}</div>
        </div>

        <QuestionLibraryFilter
          count={activeTab === "my" ? totalRealCount : totalPublicRealCount}
          countLabel="Number of Questions"
          searchAriaLabel="Search questions"
        />
        {error && <div className="alert alert-danger">{error}</div>}

        {loading ? (
          <div style={{ padding: 24 }}>
            <Stack spacing={2}>
              <Skeleton variant="rectangular" width="100%" height={48} />

              {Array.from({ length: 6 }).map((_, index) => (
                <Stack key={index} direction="row" spacing={2} alignItems="center">
                  <Skeleton variant="rectangular" width="100%" height={50} />
                </Stack>
              ))}
            </Stack>
          </div>
        ) : (
          <>
            <QuestionLibraryList
              items={activeItems}
              onView={goToView}
              onEdit={goToEdit}
              onDelete={handleDeleteQuestion}
              activeTab={activeTab}
            />

            <AssessmentPagination
              page={currentPage}
              pageSize={pageSize}
              totalCount={activeTab === "my" ? totalRealCount : totalPublicRealCount}
              onPageChange={changePage}
              onPageSizeChange={changePageSize}
            />
          </>
        )}
      </section>
    </ContentWrapper>
  );
}

function QuestionLibraryProviders({ children }) {
  return (
    <QuestionMetaProvider>
      <QuestionLibraryProvider>
        <ViewQuestionProvider>
          {children}
        </ViewQuestionProvider>
      </QuestionLibraryProvider>
    </QuestionMetaProvider>
  );
}

export default function QuestionLibrarySection() {
  return (
    <QuestionLibraryProviders>
      <QuestionLibrarySectionContent />
    </QuestionLibraryProviders>
  );
}